import {
  ContactValidationResult,
  IdentityVerificationResult,
  ISavePhoneNumberPayload,
} from 'api/file/interfaces/get-file-order-insights';
import { handleError } from 'utilities/utilities';
import { getApiHost } from '../host-by-env';

export async function validateContactInfo(
  payload: ISavePhoneNumberPayload,
  token: string,
): Promise<ContactValidationResult> {
  const url = `${getApiHost()}marketplace/services/contact-validation`;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.result;
}

export async function verifyIdentity(
  payload: ISavePhoneNumberPayload,
  token: string,
): Promise<IdentityVerificationResult> {
  const url = `${getApiHost()}marketplace/services/identity-verification`;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.result;
}
